import { css } from '@emotion/react';
import type {
  HTMLAttributes, PropsWithChildren,
} from 'react';
import type { Theme } from '~/_shared/themes/theme.model';

const rectangleTagStyle = (theme: Theme) => css({
  backgroundColor: theme.buttonColors.primaryBackground,
  borderRadius: 4,
  boxSizing: 'border-box',
  color: theme.buttonColors.primaryText,
  fontSize: 12,
  fontWeight: 500,
  padding: 4,
});

export const RectangleTag = ({ children, ...restProps }: PropsWithChildren & HTMLAttributes<HTMLDivElement>) => {
  return (
    <div
      css={rectangleTagStyle}
      {...restProps}
    >
      {children}
    </div>
  );
};
